<!-- Menu para cambiar de token -->
<p-toast></p-toast>
<div class="row pd-15" *ngFor="let data of device">
    <span>
        <div class="fs-12">{{data.name == null || data.name === '' ? 'Dispositivo Sin Nombre':data.name}}
            <span class="fR">
                <!-- <button pButton pRipple type="radio" icon="pi pi-refresh" pTooltip="Reiniciar dispositivo"
                    tooltipPosition="top" class="p-button-raised p-button-secondary mr-10" (click)="sendCRM()"></button>
                <button pButton pRipple type="button" icon="pi pi-replay" pTooltip="Sincronizar dispositivo" tooltipPosition="top"
                    class="p-button-raised p-button-secondary mr-10"></button> -->
                <!-- <button *ngIf="data.name==='test'" pButton pRipple type="button" icon="pi pi-check"
                    pTooltip="Activar número" tooltipPosition="top" class="p-button-raised p-button-success mr-10"
                    (click)="sendCEM()">
                </button>
                <button *ngIf="data.name!=='test'" pButton pRipple type="button" icon="pi pi-check"
                    pTooltip="Activar número" tooltipPosition="top" class="p-button-raised p-button-secondary mr-10"
                    (click)="sendCEM()">
                </button> -->
                <input name="activar" type="radio" [checked]="data.checked" (click)="activarNumero(data)" >
                <!--  <button pButton pRipple type="button" pTooltip="Activar número" tooltipPosition="top"
                    class="p-button-raised p-button-info mr-10" (click)="sendCEM()">
                </button> -->
            </span>
        </div>
        <!-- <div class="fs-14">{{data.number}}</div> -->
    </span>

</div>


<!-- <div class="flex flex-wrap gap-3">
    <div class="flex align-items-center">
        <p-radioButton name="pizza" value="Cheese" [(ngModel)]="ingredient" inputId="ingredient1"></p-radioButton>
        <label for="ingredient1" class="ml-2">Cheese</label>
    </div>
    
    <div class="flex align-items-center">
        <p-radioButton name="pizza" value="Mushroom" [(ngModel)]="ingredient" inputId="ingredient2"></p-radioButton>
        <label for="ingredient2" class="ml-2">Mushroom</label>
    </div>
    
    <div class="flex align-items-center">
        <p-radioButton name="pizza" value="Pepper" [(ngModel)]="ingredient" inputId="ingredient3"></p-radioButton>
        <label for="ingredient3" class="ml-2">Pepper</label>
    </div>

    <div class="flex align-items-center">
        <p-radioButton name="pizza" value="Onion" [(ngModel)]="ingredient" inputId="ingredient4"></p-radioButton>
        <label for="ingredient4" class="ml-2">Onion</label>
    </div>
</div> -->